import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { domain } from 'process';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { loginModel } from '../models/loginModel';


@Injectable({
  providedIn: 'root'
})
export class UserManagementService {

  LoginUserName: string;
  LoginToken: any;
  LoginInsertDate: string;
  loginStatus = new BehaviorSubject<boolean>(this.hasToken());
  constructor(private _http: HttpClient, private _cookieSvc: CookieService, private router: Router) { }

  login(loginModel: loginModel): Observable<any> {
    return this._http.post<any>(environment.config.BASE_API_URL + 'account/PostEmployeeLogin', loginModel)
      .pipe(
        tap((resp) => {
          if (resp.Token) {
            this._cookieSvc.set("currentUser", resp.Token );
            localStorage.setItem('userName', resp.Username);
            this.loginStatus.next(true);
          }
          return resp;
        }),
      );

  }
  isLoggedIn(){
    return this.hasToken();
  }
  /**
    * if we have token the user is loggedIn
    * @returns {boolean}
    */
  private hasToken(): boolean {
    return this._cookieSvc.check('currentUser');
  }

  logout() {
    this.loginStatus.next(false);

    this._cookieSvc.delete('currentUser', '/');
    this._cookieSvc.deleteAll();
    localStorage.removeItem('userName');
    this.router.navigate(['']);
  }

}